export enum size {
  mobileS = '320px',
  mobileM = '375px',
  mobileL = '425px',
  tablet = '768px',
  laptop = '1024px',
  laptopM = '1280px',
  laptopL = '1440px',
  desktop = '1920px',
}
